import { CheckCircle2, ShieldCheck, GraduationCap, Briefcase, Smartphone, Mail, Camera } from "lucide-react";

const MAP = {
  mobile: { label: "Mobile", icon: Smartphone },
  email: { label: "Email", icon: Mail },
  photo: { label: "Photo", icon: Camera },
  identity: { label: "ID", icon: ShieldCheck },
  education: { label: "Education", icon: GraduationCap },
  employment: { label: "Employment", icon: Briefcase },
};

export function VerifiedBadges({ verification = {}, compact = false }) {
  const active = Object.entries(MAP).filter(([k]) => verification[k]);
  if (compact) {
    if (active.length === 0) return null;
    return (
      <span className="inline-flex items-center gap-1 text-[11px] font-semibold text-sky-800 bg-sky-50 border border-sky-200 px-2 py-0.5 rounded-full" data-testid="verified-badge">
        <ShieldCheck className="w-3 h-3" /> {active.length} Verified
      </span>
    );
  }
  return (
    <div className="flex flex-wrap gap-2" data-testid="verification-badges">
      {Object.entries(MAP).map(([k, { label, icon: Icon }]) => {
        const ok = verification[k];
        return (
          <span key={k} className={`inline-flex items-center gap-1.5 text-xs font-semibold px-2.5 py-1 rounded-full border ${ok ? "text-sky-800 bg-sky-50 border-sky-200" : "text-slate-400 bg-slate-50 border-slate-200"}`}>
            {ok ? <CheckCircle2 className="w-3.5 h-3.5" /> : <Icon className="w-3.5 h-3.5" />} {label}
          </span>
        );
      })}
    </div>
  );
}
